import React from 'react';
import { FaStar } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function About() {
  const team = [
    {
      id: 1,
      name: 'Μαρία Παπαδοπούλου',
      role: 'Επικεφαλής Pastry Chef',
      bio: 'Με 15 χρόνια εμπειρίας σε κορυφαία ζαχαροπλαστεία της Γαλλίας, η Μαρία φέρνει την τέχνη της patisserie στην Ελλάδα με πάθος και αφοσίωση.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Ελένη Κωνσταντίνου',
      role: 'Ειδικός Διακόσμησης',
      bio: 'Η Ελένη ειδικεύεται στη διακόσμηση τούρτων και την τέχνη του sugar art, δημιουργώντας αληθινά έργα τέχνης από ζάχαρη και fondant.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Νίκος Αθανασίου',
      role: 'Σεφ Σοκολάτας',
      bio: 'Ο Νίκος είναι ειδικός στην επεξεργασία σοκολάτας και στη δημιουργία πραλίνας, με εκπαίδευση από το Βέλγιο και την Ελβετία.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Σοφία Δημητρίου',
      role: 'Αρτοποιός και Viennoiserie',
      bio: 'Η Σοφία ειδικεύεται στην παρασκευή croissants, brioche και άλλων γαλλικών προϊόντων viennoiserie με παραδοσιακές τεχνικές.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Γιώργος Νικολάου',
      role: 'Συγγραφέας Συνταγών',
      bio: 'Ο Γιώργος είναι υπεύθυνος για την ανάπτυξη και δοκιμή νέων συνταγών, συνδυάζοντας παραδοσιακές και σύγχρονες τεχνικές ζαχαροπλαστικής.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta name="description" content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές" />
      </Helmet>

      <div className="about-container">
      <div className="about-hero">
        <h1>Σχετικά με το Neralen</h1>
        <p>
          Το Neralen ιδρύθηκε το 2017 με όραμα να φέρει την υψηλή ζαχαροπλαστική τέχνη 
          στο σπίτι κάθε Έλληνα. Η ομάδα μας αποτελείται από επαγγελματίες pastry chefs 
          με πολυετή εμπειρία σε κορυφαία ζαχαροπλαστεία της Ευρώπης, που μοιράζονται 
          το πάθος τους για τη δημιουργία εξαιρετικών γλυκών.
        </p>
        <p>
          Πιστεύουμε ότι η ζαχαροπλαστική είναι τέχνη που συνδυάζει δημιουργικότητα, 
          επιστήμη και αγάπη. Κάθε συνταγή που δημοσιεύουμε έχει δοκιμαστεί πολλές φορές 
          για να εξασφαλίσουμε την τέλεια γεύση και υφή. Η αποστολή μας είναι να σας 
          εμπνεύσουμε και να σας εξοπλίσουμε με τις γνώσεις και τις τεχνικές που 
          χρειάζεστε για να δημιουργήσετε αξέχαστες γλυκές στιγμές.
        </p>
      </div>

      <div className="team-section">
        <h2>Η Ομάδα Μας</h2>
        <div className="team-grid">
          {team.map(member => (
            <div key={member.id} className="team-card">
              <img 
                src={member.image} 
                alt={member.name} 
                className="team-image"
                width="400"
                height="400"
              />
              <h3>{member.name}</h3>
              <p className="team-role"><FaStar /> {member.role}</p>
              <p className="team-bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="about-blog-section">
        <h2>Η Φιλοσοφία Μας</h2>
        <p>
          Στο Neralen, κάθε συνταγή είναι μια ιστορία, κάθε τεχνική είναι μια παράδοση, 
          και κάθε γλυκό είναι μια ευκαιρία να δημιουργήσετε μαγικές στιγμές. Δεν 
          περιοριζόμαστε απλά στο να μοιραστούμε συνταγές, αλλά στοχεύουμε να εκπαιδεύσουμε, 
          να εμπνεύσουμε και να δημιουργήσουμε μια κοινότητα ανθρώπων που μοιράζονται την 
          αγάπη για τη ζαχαροπλαστική τέχνη.
        </p>
        <p>
          Η προσέγγισή μας βασίζεται στην ισορροπία μεταξύ παράδοσης και καινοτομίας. 
          Σεβόμαστε τις κλασικές τεχνικές που έχουν δοκιμαστεί από γενιές ζαχαροπλαστών, 
          αλλά δεν φοβόμαστε να πειραματιστούμε με νέα υλικά, γεύσεις και μεθόδους. 
          Πιστεύουμε ότι η τέλεια ζαχαροπλαστική προκύπτει από την κατανόηση των βασικών 
          αρχών και την ελευθερία να εκφραστείτε δημιουργικά.
        </p>
        <p>
          Κάθε μέλος της ομάδας μας φέρνει τη δική του μοναδική εμπειρία και ειδίκευση, 
          δημιουργώντας έναν πλούσιο συνδυασμό γνώσεων που καλύπτει κάθε πτυχή της 
          ζαχαροπλαστικής τέχνης. Από την κλασική γαλλική patisserie μέχρι τη μοντέρνα 
          μοριακή γαστρονομία, από τη βελγική σοκολάτα μέχρι την ιταλική gelato, 
          καλύπτουμε όλο το φάσμα της γλυκιάς δημιουργίας.
        </p>
      </div>
    </div>
  
    </>);
}

export default About;